import React from "react";
import { Button as BUTTON } from "antd";
import { colors } from "../constants/enums";

const Button = ({
  icon,
  htmlType,
  title,
  type,
  alt,
  onClick,
  disabled,
  loading,
}) => {
  const buttonStyles = {
    primary: {
      color: colors.white,
      backgroundColor: colors.primaryBlue,
    },
    secondary: {
      color: colors.black,
      backgroundColor: colors.grey,
    },
    cancel: {
      color: colors.white,
      backgroundColor: colors.red,
    },
    cancelV2: {
      color: "#FF3750",
      border: "1px solid #FF3750",
      backgroundColor: colors.white,
    },
    card: {
      color: "#11D400",
      border: "1px solid #11D400",
      backgroundColor: colors.white,
    },
    cardV1: {
      color: colors.white,
      backgroundColor: "#11D400",
    },
    white: {
      color: colors.primaryBlue,
      backgroundColor: colors.white,
      className: "!bg-red",
    },
    logout: {
      color: "#FF3750",
      border: "1px solid #FF3750",
    },
    browseImage: {
      color: colors.primaryBlue,
      backgroundColor: "transparent",
      border: "1.486px solid #4A83FD",
    },
    disabled: {
      color: "#9e9e9e",
      backgroundColor: "#f3f4f6",
      border: "#cbd5e1",
    },
  };

  return (
    <BUTTON
      htmlType={htmlType}
      className={`flex items-center text-center justify-center w-full h-11 font-bold text-wrap rounded-lg`}
      disabled={disabled}
      loading={loading}
      style={buttonStyles?.[type]}
      onClick={onClick}
    >
      {icon && <img src={icon} className="mr-0.4" alt={alt} />}
      {title}
    </BUTTON>
  );
};

export default Button;
